module.exports = __webpack_public_path__ + "static/groupsession-be5205cd012dda4938c34258c5fcbec1.jpg";